module.exports = __webpack_public_path__ + "img/removelog.234806e0.png";